import React, { FC } from 'react'
import { makeStyles } from '@material-ui/styles'
import classNames from 'classnames'

import StylesModule from 'components/lv2/NumHeadlineTitle.module.scss'
import SvgCrossBg from 'images/cross-bg.svg'
import Svg01Bg from 'images/top/icon_numer01.svg'
import Svg02Bg from 'images/top/icon_numer02.svg'
import Svg03Bg from 'images/top/icon_numer03.svg'
import Svg04Bg from 'images/top/icon_numer04.svg'
import Svg05Bg from 'images/top/icon_numer05.svg'
import Svg06Bg from 'images/top/icon_numer06.svg'
import Svg07Bg from 'images/top/icon_numer07.svg'
import Svg08Bg from 'images/top/icon_numer08.svg'

export interface NumHeadlineTextProps {
  num: string
  headline: string
  title: string
}

const useStyles = makeStyles(() => ({
  bgImage: {
    backgroundImage: `url(${SvgCrossBg})`,
  },
  Svg1Bg: {
    backgroundImage: `url(${Svg01Bg})`,
  },
  Svg2Bg: {
    backgroundImage: `url(${Svg02Bg})`,
  },
  Svg3Bg: {
    backgroundImage: `url(${Svg03Bg})`,
  },
  Svg4Bg: {
    backgroundImage: `url(${Svg04Bg})`,
  },
  Svg5Bg: {
    backgroundImage: `url(${Svg05Bg})`,
  },
  Svg6Bg: {
    backgroundImage: `url(${Svg06Bg})`,
  },
  Svg7Bg: {
    backgroundImage: `url(${Svg07Bg})`,
  },
  Svg8Bg: {
    backgroundImage: `url(${Svg08Bg})`,
  },
}))

const NumHeadlineText: FC<NumHeadlineTextProps> = ({
  num,
  headline,
  title,
}) => {
  const classes = useStyles()
  const SvgName = 'Svg' + num + 'Bg'
  return (
    <div className={classNames(StylesModule.numHeadlineTitle)}>
      <div
        className={classNames(
          StylesModule.numHeadlineTitle__cross,
          classes.bgImage,
        )}
      ></div>
      <div
        className={classNames(
          classes[SvgName],
          StylesModule.numHeadlineTitle__num,
        )}
      ></div>
      <div className={classNames(StylesModule.numHeadlineTitle__textWrap)}>
        <div className={classNames(StylesModule.numHeadlineTitle__headline)}>
          {headline}
        </div>
        <div className={classNames(StylesModule.numHeadlineTitle__title)}>
          {title}
        </div>
      </div>
    </div>
  )
}

export default NumHeadlineText
